import { VideoResponsive } from './styles';

type props = {
  videoUrl: string
  videoTitle: string
};

const YoutubeEmbed = (props: props) => (
  <VideoResponsive>
    <iframe
      src={props.videoUrl}
      frameBorder="0" // NOSONAR - deprecated attribute but required for cross-browser iframe compatibility
      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
      allowFullScreen
      title={props.videoTitle}
    />
  </VideoResponsive>
);

export default YoutubeEmbed;
